import React, { useState } from 'react';
import { Alert, Button, Form, Modal, Spinner } from 'react-bootstrap';

export default function ReportDialog({ show, onClose, title = 'Report content', reasons = [], onSubmit }) {
  const [reason, setReason] = useState('');
  const [otherReason, setOtherReason] = useState('');
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');

  const close = () => {
    if (busy) return;
    setReason('');
    setOtherReason('');
    setMessage('');
    onClose?.();
  };

  const submit = async () => {
    setMessage('');
    if (!reason) {
      setMessage('Select a reason for reporting.');
      return;
    }
    if (reason === 'Other' && !otherReason.trim()) {
      setMessage('Describe the reason for this report.');
      return;
    }
    setBusy(true);
    try {
      await onSubmit?.(reason, otherReason.trim());
      setMessage('Report submitted. Our moderation team can now review it.');
      window.setTimeout(close, 900);
    } catch (error) {
      setMessage(error?.message || 'The report could not be submitted.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal show={show} onHide={close} centered>
      <Modal.Header closeButton><Modal.Title>{title}</Modal.Title></Modal.Header>
      <Modal.Body>
        {message && <Alert variant={message.startsWith('Report submitted') ? 'success' : 'danger'}>{message}</Alert>}
        <Form>
          {reasons.map((item) => (
            <Form.Check
              key={item}
              type="radio"
              name="p4r-report-reason"
              id={`report-${item.replace(/\W+/g, '-').toLowerCase()}`}
              label={item}
              value={item}
              checked={reason === item}
              onChange={(event) => setReason(event.target.value)}
              className="mb-2"
            />
          ))}
          {reason === 'Other' && (
            <Form.Control
              as="textarea"
              rows={3}
              maxLength={500}
              value={otherReason}
              onChange={(event) => setOtherReason(event.target.value)}
              placeholder="Tell us what happened"
              className="mt-3"
            />
          )}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={close} disabled={busy}>Cancel</Button>
        <Button variant="danger" onClick={submit} disabled={busy || !reason}>
          {busy ? <><Spinner size="sm" /> Submitting</> : 'Submit report'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
